import React from 'react';
import PropTypes from 'prop-types';
import ExpertiseList from './ExpertiseList';
import CustomTooltip from '../../Utils/CustomTooltip';

const AreasOfExpertise = ({ expertise, showSources = true }) => {
  // Helper function to get items array, checking both 'items' and 'value' properties
  const getItemsArray = (data) => {
    if (Array.isArray(data?.items) && data.items.length > 0) {
      return data.items;
    } else if (Array.isArray(data?.value) && data.value.length > 0) {
      return data.value;
    }
    return [];
  };
  
  // Get the expertise array
  const expertiseArray = getItemsArray(expertise);
  return (
    <div className="border border-gray-200 rounded-lg p-6 bg-white">
      <div className="flex justify-between items-start mb-4">
        <h4 className="text-xl font-semibold text-gray-800">Areas of Expertise</h4>
        {showSources && expertise?.source && (
          <CustomTooltip content={expertise.source} position="left">
            <span className="text-xs text-blue-600 cursor-help hover:text-blue-800 flex items-center">
              <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
              Source
            </span>
          </CustomTooltip>
        )}
      </div>
      
      {expertiseArray.length > 0 ? (
        <ExpertiseList expertiseItems={expertiseArray} showSources={showSources} />
      ) : (
        <p className="text-gray-600">No expertise data available.</p>
      )}
    </div>
  );
};

AreasOfExpertise.propTypes = {
  expertise: PropTypes.object,
  showSources: PropTypes.bool
};

export default AreasOfExpertise;
